import React from "react";
import clsx from "clsx";
import TimePickerInput from "../../TimePickerInput/TimePickerInput";
import Switch from "../../Switch/Switch";
import ReservationSettingErrors from "../ReservationSettingErrors";
import NumberSpinner from "../../NumberSpinner/NumberSpinner";
import DateHelper from "../../DateHelper/DateHelper";

export default class ReservationSettingBuilderGeneral extends React.Component {
  constructor(props) {
    super(props);

    this.renderFieldClasses = this.renderFieldClasses.bind(this);
    this.renderFieldErrors = this.renderFieldErrors.bind(this);
    this.renderErrors = this.renderErrors.bind(this);
  }

  render() {
    var tabClasses = clsx({
      active: this.props.active_tab == "reservation_settings",
      "tab-pane": true,
    });
    return (
      <div className={tabClasses} id="general">
        {this.renderErrors()}
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label style={{ marginRight: "4px" }}>{`${I18n.t(
                "check_in_time"
              )}*`}</label>
              <span
                className="ss-help help"
                title={I18n.t("default_check_in_time_helper_text")}
              ></span>
              <br />
              <TimePickerInput
                format={DateHelper.rubyToDateFNS(this.props.time_format) }
                selectedTime={
                  this.props.check_in_time ? this.props.check_in_time : ''
                }
                className={` check-in-time ${this.renderFieldClasses('reservation_setting.check_in_time')}`}
                onChange={this.props.onChangeCheckIn}
                offsetTime={false}
              />
              {this.renderFieldErrors("reservation_setting.check_in_time")}
            </div>
          </div>

          <div className="col-sm-6">
            <div className="form-group">
              <label style={{ marginRight: "4px" }}>{`${I18n.t(
                "check_out_time"
              )}*`}</label>
              <span
                className="ss-help help"
                title={I18n.t("default_check_out_time_helper_text")}
              ></span>
              <br />
              
              <TimePickerInput
                format={DateHelper.rubyToDateFNS(this.props.time_format)}
                selectedTime={
                  this.props.check_out_time ? this.props.check_out_time : ''
                }
                className={` check-out-time ${this.renderFieldClasses('reservation_setting.check_out_time')}`}
                onChange={this.props.onChangeCheckOut}
                offsetTime={false}
              />
              {this.renderFieldErrors("reservation_setting.check_out_time")}
            </div>
          </div>
        </div>

        <div className="row">

          <div className="col-sm-6">
            <div className="form-group">
              <label style={{ marginRight: "4px" }}>
                {I18n.t("maximum_stay")}
              </label>
              <span
                className="ss-help help"
                title={I18n.t("maximum_stay_helper_text")}
              ></span>
              <br />
              <div className="input-group bootstrap-timepicker">
                <input
                  className={`input-small ${this.renderFieldClasses(
                    "reservation_setting.maximum_stay"
                  )} form-control`}
                  type="text"
                  value={this.props.maximum_stay || ""}
                  onChange={this.props.onChange}
                  name="maximum_stay"
                />
                <div className="input-group-append">
                  <span className="input-group-text">{I18n.t("days")}</span>
                </div>
              </div>
              {this.renderFieldErrors("reservation_setting.maximum_stay")}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label style={{ marginRight: "4px" }}>
                {I18n.t("date_format")}
              </label>
              <span
                className="ss-help help"
                title={I18n.t("reservation_default_date_format_helper_text")}
              ></span>
              <br />
              <select
                className="form-control"
                onChange={this.props.onChangeDate}
                value={
                  this.props.date_format
                    ? this.props.date_format
                    : I18n.t("please_select")
                }
              >
                <option> {I18n.t("please_select")} </option>
                {Object.keys(this.props.date_formats).map((format, idx) => {
                  return (
                    <option key={idx} value={this.props.date_formats[format]}>
                      {format}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label style={{ marginRight: "4px" }}>
                {" "}
                {I18n.t("time_format")}{" "}
              </label>
              <span
                className="ss-help help"
                title={I18n.t("reservation_default_time_format_helper_text")}
              ></span>
              <br />
              <select
                className="form-control"
                onChange={this.props.onChangeTime}
                value={
                  this.props.time_format
                    ? this.props.time_format
                    : I18n.t("please_select")
                }
              >
                <option> {I18n.t("please_select")} </option>
                {Object.keys(this.props.time_formats).map((format, idx) => {
                  return (
                    <option key={idx} value={this.props.time_formats[format]}>
                      {" "}
                      {format}{" "}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        </div>

        <div className="row">
         <div className="col-md">
            <div className="form-group" style={{marginBottom: 0}}>
              <label>{I18n.t("default_check_in_date")}* <span className="ss-help help" title={I18n.t('default_check_in_date_helper_text')}></span></label>
              <NumberSpinner
                name="default_number_of_nights"
                value={this.props.default_check_in_date}
                onChange={this.props.onChangeDefaultCheckInDate}
                min={0}
								max={7}
                className="form-control"
              />
            </div>
          </div>
          <div className="col-md">
            <div className="form-group" style={{marginBottom: 0}}>
              <label>{I18n.t("default_number_of_nights")}* <span className="ss-help help" title={I18n.t('default_number_of_nights_helper_text')}></span></label>
              <NumberSpinner
                name="default_number_of_nights"
                value={this.props.default_number_of_nights}
                onChange={this.props.onChangeDefaultNumberOfNights}
                min={1}
								max={7}
                className="form-control"
              />
            </div>
          </div>
          <div className="col-md">
            <div className="form-group" style={{marginBottom: 0}}>
              <label>{I18n.t("booking_window_days")}*</label>
              <NumberSpinner
                name="booking_window_days"
                value={this.props.booking_window_days}
                onChange={this.props.onChange}
                min={182}
                max={730}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderErrors() {
    if (this.props.errors) {
      var errors = ReservationSettingErrors.general(this.props.errors);
    }

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>;
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map((error) => {
        idx = idx + 1;
        return (
          <li key={idx}>
            <b>&#x2022;</b> {error}
          </li>
        );
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldClasses(field) {
    var classname = "form-control";
    if (
      this.props.errors &&
      Object.keys(this.props.errors).length &&
      this.props.errors[field]
    ) {
      classname = classname + " has-errors";
    }
    return classname;
  }
}
